import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GetTopProductRequest, TopProductsResponse, useTopProduct } from '../../../../api/indicators';
import { UserContext } from '../../../../context/UserContext';
import { DashboardFiltersContext } from '../filters/DashboardFiltersContext';
import { dateRange } from '../../../../helpers/dateUtils';
import PieBarChart, { PieBarChartData } from '../charts/PieBarChart';
import { DashboardContext } from '../../DashboardContext';


const DEFAULT_LIMIT_PRODUCTS = 10;

const SalesByProduct = () => {
    const { t } = useTranslation();
    const { locale } = useContext(UserContext);
    const { filters, dateRangeConfig } = useContext(DashboardFiltersContext);
    const { refreshDate } = useContext(DashboardContext);
    const [ params, setParams ] = useState<GetTopProductRequest>({
        fields: 'saleValue',
        startDateTime: filters.periodFrom ? filters.periodFrom : dateRange("today", undefined, undefined, undefined, dateRangeConfig).startDate,
        endDateTime:filters.periodTo ? filters.periodTo : dateRange("today", undefined, undefined, undefined, dateRangeConfig).endDate,
        locations: filters?.locations?.join(','),
        locationArea: filters?.locationArea?.id,
        limit: DEFAULT_LIMIT_PRODUCTS
    });

    const {
        data: topProductsResponse,
        isLoading,
        isError,
        refetch: fetchTopProducts
    } = useTopProduct<TopProductsResponse>(params, 'sales-by-product');

    useEffect(() => {
        setParams(p => ({
            ...p,
            startDateTime: filters.periodFrom || dateRange("today", undefined, undefined, undefined, dateRangeConfig).startDate,
            endDateTime:filters.periodTo || dateRange("today", undefined, undefined, undefined, dateRangeConfig).endDate,
            locations: filters?.locations?.join(','),
            locationArea: filters?.locationArea?.id
        }));
    }, [filters, dateRangeConfig]);

    useEffect(() => {fetchTopProducts();}, [params, fetchTopProducts]);

    useEffect(() => {
        if (refreshDate != null) {
            fetchTopProducts();
        }
    }, [refreshDate, fetchTopProducts]);

    return (
        <PieBarChart
            title={t("screens.dashboarding.charts.salesByProduct")}
            description={t("screens.dashboarding.charts.includingTax")}
            data={topProductsResponse?.topProducts?.saleValue?.map(v => ({
                value: v.saleValue,
                label: v.productName,
            })) as PieBarChartData[]}
            currency={topProductsResponse?.currency}
            locale={locale}
            isLoading={isLoading}
            error={isError}
            reportName={t('screens.dashboarding.charts.salesByProduct')}
            reportLink={`${process.env.REACT_APP_LINK_BACK_OFFICE}Pages/Reporting/DailySales.aspx`}
        />
    )
}

export default SalesByProduct;
